import {flattenValue, FlattenValueOptions} from 'notebook/tables/typed-values/DataTypes';

import {isCustomServerResolutionResult, ServerResolutionResult} from './StringResolutionConstants';

/**
 * CustomResolution for Lookup Columns can return an array of values which should be flattened to a multi-link
 * TypedValue instead.  This function should be called when returning Lookup Columns from the server to
 * ensure that we get the expected shape for the return value.
 *
 * Once we finish BNCH-52937, we can remove this and just have the backend correctly produce the right shape
 * for the values.
 *
 * TODO(BNCH-52937): remove once we're able to flatten these values on the backend
 *
 * @param serverResolutionResults the array of StringResolutionResults
 * @returns an Array of ServerResolutionResults
 */
export function flattenCustomResolutionResults(
  serverResolutionResults: Array<ServerResolutionResult>,
  options: FlattenValueOptions = {}
): Array<ServerResolutionResult> {
  return serverResolutionResults.map((serverResolutionResult) => {
    if (isCustomServerResolutionResult(serverResolutionResult)) {
      const typedValue = serverResolutionResult.resolvedValue?.typedValue;
      return {
        ...serverResolutionResult,
        resolvedValue: {typedValue: typedValue != null ? flattenValue(typedValue, options) : typedValue},
      };
    }
    return serverResolutionResult;
  });
}
